import toastWeb, { Toaster as RealToaster } from 'react-hot-toast';
import theme from '../config/theme';

type ToastType = 'default' | 'success' | 'error' | 'info' | 'warning';
const typeToColor = {
    default: theme.colors.primary.default,
    success: theme.colors.util.success,
    error: theme.colors.util.error,
    info: theme.colors.util.info,
    warning: theme.colors.util.warning,
};
const typeToIcon = {
    success: '✅',
    error: '❌',
    info: 'ℹ️',
    warning: '⚠️',
    default: '',
};

export function showToast(
    message: string,
    options?: { duration?: number; type?: ToastType; id?: string }
) {
    const type = options?.type ?? 'default';
    const toastOptions: any = {
        duration: options?.duration ?? 1000,
        icon: typeToIcon[type],
        style: {
            background: typeToColor[type],
            color: theme.colors.text.inverse,
            fontFamily: theme.fontFamily?.medium ?? 'sans-serif',
            borderRadius: theme.borderRadius.md,
            fontSize: theme.fontSizes.md,
            boxShadow: theme.shadows.md?.boxShadow ?? '0 2px 4px rgba(0,0,0,0.1)',
            padding: '12px 20px',
            minWidth: 180,
            maxWidth: 400,
        },
    };
    if (options?.id) toastOptions.id = options.id;
    toastWeb(message, toastOptions);
}

/** Componente real para injetar na árvore React */
export const Toaster = RealToaster;

export default { showToast, Toaster }; 